import { z } from 'zod'

// Компания — сущность хаба, телемост её только читает (справочник
// GET /api/companies поверх локальной проекции). Реквизиты не нужны: телемост
// выбирает компанию звонка и фильтрует списки, карточку показывает хаб.
export const CompanySchema = z.object({
  id: z.string(),
  name: z.string(),
  slug: z.string().optional(),
})

export type Company = z.infer<typeof CompanySchema>
